import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function PopularComics() {
  const featured = comics.filter((c) => c.featured).slice(0, 4);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-sm font-semibold tracking-wide text-primary-600">本周热追</span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">人气连载抢先看</h2>
            <p className="mt-3 text-foreground-600">漫画迷都在追的作品，收藏即可开启连载更新提醒。</p>
          </div>
          <Link
            to="/comics"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-background-300/70 px-5 py-2.5 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-700"
          >
            查看全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {featured.map((comic) => (
            <article
              key={comic.id}
              className="group overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title} 漫画封面`}
                  title={`${comic.title} ${comic.category} 漫画`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-950/70 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
                  {comic.category}
                </span>
                <span
                  className={`absolute right-3 top-3 rounded-full px-3 py-1 text-xs font-medium ${
                    comic.status === '连载中'
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-accent-500 text-foreground-950'
                  }`}
                >
                  {comic.status}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-bold text-foreground-950 md:text-lg">{comic.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">{comic.author}</p>
                <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3">
                  <span className="text-xs text-foreground-600">{comic.latestChapter}</span>
                  <span className="flex items-center gap-1 text-xs font-semibold text-accent-700">
                    <i className="ri-star-fill"></i>
                    {comic.rating}
                  </span>
                </div>
                <div className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-bookmark-line text-primary-500"></i>
                  {comic.progress}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}